import React from 'react'
import moment from "moment";
import PageHeader from "../../../../components/PageHeader";
import Sidebar from "../../../../components/Sidebar";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import SchoolTimeManagement from "./school-year";
import ClassManagement from "./class";
import DepartmentManagement from "./department";

class DataDeclarationManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoading: false,
        }
    }
    render() {
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="declaration-management" parentClass="system-school-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className='pt-3 mb-4'>
                                    <PageHeader routerEnable={true} title="Khai báo dữ liệu"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className='col-xs-12 col-sm-12 col-md-12 text-left pl-0 mt-3'>
                                                <Tabs>
                                                    <TabList>
                                                        <Tab>Năm học</Tab>
                                                        <Tab>Tổ bộ môn</Tab>
                                                        <Tab>Lớp học</Tab>
                                                    </TabList>
                                                    <TabPanel>
                                                        <SchoolTimeManagement />
                                                    </TabPanel>
                                                    <TabPanel>
                                                        <DepartmentManagement />
                                                    </TabPanel>
                                                    <TabPanel>
                                                        <ClassManagement />
                                                    </TabPanel>
                                                </Tabs>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default DataDeclarationManagement
